// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__-N9n6","content":"default_content__nqWU2","column":"default_column__Hva1A"};